module.exports = __webpack_public_path__ + "img/n6-bg5.006d1ff0.png";